import React from 'react';
import MuiModal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import styled from 'styled-components';

export const ModalWrapper = ({ children, ...props }) => (
  // eslint-disable-next-line no-use-before-define
  <MuiModal {...props} BackdropComponent={BackdropComponent}>
    {children}
  </MuiModal>
);

const BackdropComponent = styled(Backdrop)`
  &.MuiBackdrop-root {
    background-color: ${({ theme }) => theme?.colors?.greyOverlay};
  }
`;
